import { useState } from 'react'
import { useRef, useEffect } from 'react'
import classes from './masnoryGrid.module.css'
import ReviewCard from '../ReviewCard'

const MasnoryGrid = ({ reviewsData, config }) => {
  const containerRef = useRef(null)

  const [reviewData, setReviewData] = useState([])

  useEffect(() => {
    console.log(containerRef.current)
    const childElementCount = containerRef.current.childElementCount

    // for (let i = 0; i < childElementCount; i++) {
    //   if (i !== 0) {
    //     containerRef.current.children[i].style.transform = `translateX(${
    //       i % 3 ? (i % 3) * 300 : 3 * 300
    //     }px)`
    //   }
    // }

    // for (let i = 0; i <= Math.floor(childElementCount / 3); i++) {
    //   for(let j =0; j < 3; j++){

    //   }
    // }
  }, [containerRef])

  useEffect(() => {
    window.addEventListener('resize', orderReviewData)
  }, [])

  useEffect(() => {
    orderReviewData()
  }, [reviewsData])

  const orderReviewData = () => {
    const cols = window.innerWidth < 600 ? 1 : window.innerWidth < 900 ? 2 : 3
    if (cols === 1) {
      setReviewData([reviewsData])
    } else if (cols === 2) {
      setReviewData([reviewsData.slice(0, Math.floor(reviewsData.length / 2))])
      setReviewData([reviewsData.slice(Math.floor(reviewsData.length / 2))])
    } else {
      setReviewData([
        reviewsData.slice(0, Math.floor(reviewsData.length / 3)),
        reviewsData.slice(
          Math.floor((reviewsData.length * 1) / 3),
          Math.floor((reviewsData.length * 2) / 3)
        ),
        reviewsData.slice(Math.floor((reviewsData.length * 2) / 3))
      ])
    }
  }

  return (
    <div>
      <div ref={containerRef} className={classes.masnoryContainer}>
        {reviewData.map((col, ind) => (
          <div key={ind}>
            {col?.map((item, index) => (
              <ReviewCard
                profileImage={item.profileImg}
                userName={item.username}
                userSubtitle={item.pageName}
                reviewText={item.review_text}
                key={index}
                cardPosition={index}
                config={config}
              />
            ))}
          </div>
        ))}
        {/* {dummyData.map((i, index) => (
          <ReviewCard
            userName={i.userName}
            userSubtitle={i.userSubtitle}
            reviewText={i.reviewText}
            key={index}
            cardPosition={index}
          />
        ))} */}
      </div>
    </div>
  )
}

export default MasnoryGrid
